// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LocalAccounts {}\n", "",{"version":3,"sources":["webpack://./src/main/frontend/Components/LocalAccounts/LocalAccounts.css"],"names":[],"mappings":"AAAA,gBAAgB","sourcesContent":[".LocalAccounts {}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
